import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Profil } from '../shared/profil';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {Router} from '@angular/router';
import {Currency} from '../shared/Currency';
import {SaleChannel} from '../shared/SaleChannel';
import {AuthService} from '../core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SaleChannelService {
  user: Profil;
  addParams: string;

  // Define API
  apiURL = 'https://apioffice.next77.pl';


  constructor(private http: HttpClient, private router: Router, private authService: AuthService) {
    this.user = this.authService.getLoggedUser();
    if(window.location.host.includes('localhost')){
      this.apiURL = 'http://localhost:3000';
    }
  }

  /*========================================
    CRUD Methods for consuming RESTful API
  =========================================*/

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // Orders
  getSaleChannels(): Observable<[SaleChannel]> {
    return this.http.get<[SaleChannel]>(
      this.apiURL + '/sales-channels',
      {}
    ).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  getSaleChannel( id ): Observable<SaleChannel> {
    return this.http.get<SaleChannel>(
      this.apiURL + '/sales-channels/' + id
    ).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  updateSaleChannel(id, data): Observable<SaleChannel> {
    return this.http.patch<SaleChannel>(
      this.apiURL + '/sales-channels/' + id,
      JSON.stringify(data),
      this.httpOptions
    ).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  deleteSaleChannel( id: number ) {
    return this.http.delete<boolean>(this.apiURL + '/sales-channels?id='+id, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HELPERS
  checkAddWhere( addWhere, colName, colVal ) {
    if ( colVal !== undefined ) {
      if ( addWhere.length === 0 ) {
        addWhere = '?';
      } else {
        addWhere = addWhere + '&';
      }
      addWhere = addWhere + colName + '=' + colVal;
    }
    return addWhere;
  }

  // ERROR HANDLER
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
